import { Menu, MenuProps, Spin } from "antd";
import { HistoryVersionListItem } from "./history-version-list-item";
import { useSearchParams } from "../../../../../hook/use-search-params";
import { usePublicDocumentContent } from "../../../hooks";

type MenuItem = Required<MenuProps>["items"][number];

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
  type?: "group",
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
    type,
  } as MenuItem;
}

export const HistoryVersionList = () => {
  const { searchParams, replaceSearchParams } = useSearchParams();
  const version = searchParams.get("version") || "";
  const { isLoading, versionData, maxVersion } = usePublicDocumentContent();

  const selectedKey = version || maxVersion + "" || "";

  const items: MenuProps["items"] = [
    ...versionData.map((e: any) => getItem(<HistoryVersionListItem version={e} />, e + "")),
  ];

  if (isLoading) return <Spin />;

  const handleMenuClick = ({ key }: { key: string }) => {
    searchParams.set("version", key);
    replaceSearchParams(searchParams);
  };

  return (
    <div>
      <h5 className="px-2">Lịch sử ban hành</h5>
      <hr />
      <Menu items={items} onSelect={handleMenuClick} selectedKeys={[selectedKey]} />
    </div>
  );
};
